import { depositTypeOptions } from "data/constant/bank-deposit";

export const initialFilterState = () => {
  return {
    dateType: "shift",
    startDate: null,
    endDate: null,
    searchKey: "",
    order: "desc",
    type: {
      isSelectedAll: true,
      value: depositTypeOptions.map((option) => option.value),
    },
    page: 1,
    perPage: 10,
  };
};
